/**
 * "Mẫu gợi ý" on the home page: ready-made looks = a Vietmap base style, an
 * optional "Bảng màu" palette and an icon set. Opening one goes to
 * `/create?template=<id>`; App applies the three steps (App._applyStyleTemplate).
 */
export type StyleTemplate = {
  id: string;
  /** Display name (i18n key). */
  name: string;
  /** One-line description (i18n key). */
  description: string;
  /** Vietmap preset loaded first (VIETMAP_STYLE_URLS key). */
  base: "vietmap-street" | "vietmap-dark" | "vietmap-hybrid";
  /** COLOR_PALETTES id applied on top (its own base wins). */
  paletteId?: string;
  /** ICON_SETS id — SVG sets are rendered with their default colours. */
  iconSetId: string;
  /** Thumbnail background before the live preview loads (MapThumb). */
  thumbMode: 0 | 1 | 2 | 3;
};

export const STYLE_TEMPLATES: StyleTemplate[] = [
  {
    id: "street-modern",
    name: "Đường phố hiện đại",
    description: "Bản đồ Vietmap chuẩn với bộ icon Hiện đại, dễ nhìn trên mọi màn hình.",
    base: "vietmap-street",
    paletteId: "default",
    iconSetId: "modern",
    thumbMode: 0,
  },
  {
    id: "hybrid-modern",
    name: "Vệ tinh Hybrid",
    description: "Ảnh vệ tinh kèm đường và nhãn, icon Hiện đại nổi bật trên nền ảnh.",
    base: "vietmap-hybrid",
    iconSetId: "modern",
    thumbMode: 3,
  },
  {
    id: "classic-modern",
    name: "Classic",
    description: "Tông sáng kiểu Google Maps: nước xanh, công viên xanh bạc hà, icon Hiện đại.",
    base: "vietmap-street",
    paletteId: "classic",
    iconSetId: "modern",
    thumbMode: 1,
  },
  {
    id: "night-modern",
    name: "Night",
    description: "Nền xanh than, đường màu ấm cho giao diện tối, icon Hiện đại.",
    base: "vietmap-dark",
    paletteId: "night",
    iconSetId: "modern",
    thumbMode: 2,
  },
  {
    id: "voyager-flat",
    name: "Voyager",
    description: "Tông ấm, dịu mắt, icon Tròn phẳng gọn gàng cho app giao hàng, du lịch.",
    base: "vietmap-street",
    paletteId: "voyager",
    iconSetId: "flat",
    thumbMode: 1,
  },
  {
    id: "positron-flat",
    name: "Positron tối giản",
    description: "Nền xám trắng tối giản để làm nổi dữ liệu của bạn, icon Tròn phẳng.",
    base: "vietmap-street",
    paletteId: "positron",
    iconSetId: "flat",
    thumbMode: 1,
  },
  {
    id: "dark-matter-modern",
    name: "Dark Matter",
    description: "Nền đen sâu cho dashboard và màn hình giám sát, icon Hiện đại.",
    base: "vietmap-dark",
    paletteId: "dark-matter",
    iconSetId: "modern",
    thumbMode: 2,
  },
  {
    id: "navigation-pin",
    name: "Dẫn đường",
    description: "Tông tối tương phản cao cho app dẫn đường, icon Ghim nổi dễ chạm.",
    base: "vietmap-dark",
    paletteId: "navigation",
    iconSetId: "pin",
    thumbMode: 2,
  },
];
